module.exports = __webpack_public_path__ + "img/cat.48e2308b.png";